import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  title: {
    flexGrow: 1,
    justifyContent: "center",
    display: "flex",
    textDecoration: "none",
  },
  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3),
  },
  root: {
    flexGrow: 1,
  },
}));
